import { render, staticRenderFns } from "./PDFZoom.vue?vue&type=template&id=5e68e3bb&"
import script from "./PDFZoom.vue?vue&type=script&lang=js&"
export * from "./PDFZoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports